import { render, staticRenderFns } from "./ManageIncidentStatus.vue?vue&type=template&id=612573cc&scoped=true"
import script from "./ManageIncidentStatus.vue?vue&type=script&lang=js"
export * from "./ManageIncidentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612573cc",
  null
  
)

export default component.exports